import RFFInputField from '../../form/RFFInputField';
import RFFDateSelect from '../../form/RFFDateField';
import RFFRadio from '../../form/RFFRadio';
import RFFNumberInputField from '../../form/RFFNumberInputField';

export const column1 = [
  {
    name: 'unitPrice',
    label: 'Unit Price',
    component: RFFNumberInputField,
    numberFormat: '',
    thousandSeparator: true,
    prefix: '$',
    allowEmptyFormatting: false,
    labelCol: { md: 4 },

    type: 'text',
  },

  {
    name: 'q_qty',
    label: 'Quantity',
    component: RFFNumberInputField,
    labelCol: { md: 4 },

    numberFormat: '',
    type: 'text',
  },

  {
    name: 'shipping',
    label: 'Shipping Cost',
    component: RFFNumberInputField,
    numberFormat: '',
    labelCol: { md: 4 },

    allowEmptyFormatting: false,
    thousandSeparator: true,
    prefix: '$',
    type: 'text',
  },
  {
    name: 'totalCost',
    label: 'Total Cost',
    component: RFFNumberInputField,
    numberFormat: '',
    labelCol: { md: 4 },

    thousandSeparator: true,
    prefix: '$',
    type: 'text',
    disabled: true,
  },
  {
    name: 'deliveryDate',
    labelCol: { md: 4 },

    label: 'Delivery Date',
    component: RFFDateSelect,

    type: 'text',
  },
  {
    name: 'q_toolingDesc',
    label: 'Describe Tooling',
    labelCol: { md: 4 },

    component: RFFInputField,
    type: 'textarea',
  },
  {
    name: 'q_comment',
    label: 'Additional Comments',
    labelCol: { md: 4 },

    component: RFFInputField,
    type: 'textarea',
  },
];
export const column2 = [
  {
    name: 'q_toolingAvailable',
    label: 'Tooling Available?',
    labelCol: { md: 4 },

    component: RFFRadio,
    type: 'Radio',

    options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
  },
  {
    name: 'q_machiningReq',
    labelCol: { md: 4 },

    label: 'Machining Required?',
    component: RFFRadio,
    type: 'Radio',

    options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
  },
  {
    labelCol: { md: 4 },

    name: 'q_sampleAvailable',
    label: 'Sample Part Available',
    component: RFFRadio,
    type: 'Radio',

    options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
  },
];

export const ndaAcceptance = {
  labelCol: { md: 4 },

  name: 'ndaAccept',
  label: 'I agree to the terms of the NDA',
  component: RFFRadio,
  type: 'Radio',
  options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
};

// export const Comments = {};



// WEBPACK FOOTER //
// ./src/components/forms/EditQuoteForm/formConfig.jsx